import {
    Component,
    ComponentInterface,
    Prop,
    h,
    Event,
    Host,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core"

@Component({
    tag: "c-stamp-text",
    styleUrl: "c-stamp-text.scss",
    shadow: true,
})
export class CStampText implements ComponentInterface {
    @Prop() stamp?: string;
    @Prop() state?: string;
    @Prop() variant:
        | "start-theme"
        | "change-theme"
        | "suggestions-intro"
        | "job-form"
        | "form"
        | "job-form-ua"
        | "form-ua";
    @Event() themeChanged: EventEmitter;

    private static readonly BUTTON_VARIANTS = [
        "change-theme",
        "form",
        "job-form",
        "form-ua",
        "job-form-ua",
    ] as const;

    private get isButtonVariant() {
        return CStampText.BUTTON_VARIANTS.includes(this.variant as any);
    }

    private getButtonText(): string {
        switch (this.variant) {
            case "change-theme":
                return "Frage zu anderem Themenbereich stellen";
            case "form":
                return "Zurück zur Fragebogenübersicht";
            case "job-form":
                return "Abbrechen und zurück zum Hauptmenü";
            case "form-ua":
                return "Повернутися до огляду анкети";
            case "job-form-ua":
                return "Скасувати та повернутися до головного меню";
            default:
                return "";
        }
    }

    private getStampClass() {
        return this.variant === "suggestions-intro" ? "small-margin" : "";
    }

    render() {
        return (
            <Host>
                {this.isButtonVariant ? (
                    <button
                        onClick={() => this.themeChanged.emit()}
                        class="stamp-text change-theme-stamp"
                        data-analytics-track="true"
                        data-analytics-action="ButtonClicks TCB: Klick"
                        data-analytics-value={this.getButtonText()}
                        data-analytics-name="TCB: StampText Button"
                        data-analytics-category="TCB | ButtonClicks"
                    >
                        <span class="sr-only">Klicken sie für: </span>
                        {this.getButtonText()}
                    </button>
                ) : (
                    <p class={`stamp-text ${this.getStampClass()}`}>
                        {this.stamp}
                    </p>
                )}
                {this.state && (
                    <c-form-progress
                        type="horizontal"
                        stage={this.state}
                    ></c-form-progress>
                )}
            </Host>
        );
    }
}
